import React from 'react'

import CheckUserExistsModal from 'src/components/Modal/CheckUserExistsModal'

const CheckUserExistsModalPage: React.FC = () => {
  return <CheckUserExistsModal isOpen={true} />
}

export const PATH = '/check-user-exists-modal' as const
export default CheckUserExistsModalPage
